/**
 * @file 落地页页面组件
 * @author FengGuang(fengguang01@baidu.com)
 */

import React, { useEffect, useMemo, useState } from 'react';
import Header from '../../components/header/HeaderWithStore';
import Footer from '../../components/footer/footer';
import usePaddleNlpHooks from './paddlenlpHooks';
import Core from './components/core/core'
import Advantage from './components/advantage/advantage'
import Advantagen from './components/advantagen/advantagen'
import Model from './components/model/model'
import ListMap from './components/list-map/list-map'
import Online from './components/online/online'
import treepic from './image/treepic.png'
import { Button, Input } from 'antd';
import { fetchListModel, fetchOnlineListModel } from './../../api/pages/ListmapApi';
import { debounce } from 'lodash';
const Paddlenlp: React.FC = () => {

    const {
        introduce,
        coerpation,
        treeduce,
        advantage,
        model,
        advantagen,
        more
    } = usePaddleNlpHooks();
    // 中文词类知识标注工具   示例
    const [modelData, setModelData]: any = useState([]);
    const [currentValue, setCurrentValue]: any = useState('《孤女》是2010年九州出版社出版的小说，作者是余兼羽');
    const randomTextData = [
        '重大革命历史题材电视剧《觉醒年代》由中共北京市委宣传部、中共安徽省委宣传部、北京市广播电视局和安徽省广播电视局联合摄制，由北京北广传媒影视股份有限公司和安徽华星传媒投资有限公司承制',
        '苹果启用MFI连接器最严加密打击盗版，山寨数据线厂商要凉？',
        '黑米和小米营养丰富，配上苹果做成米糊，不放糖照样香甜',
        '张光北，1959年6月11日生于中国北京市，中国内地影视男演员，北京北广传媒影视有限公司副总经理兼制片人。',
        '一文字隼人是由于饰演本乡猛的演员·藤冈弘在拍摄过程中发生事故导致负伤住院而急忙诞生的角色。'
    ];
    const getTextInfo = useMemo(() => {
        return debounce(async (value: string) => {
            const data = await fetchListModel({ text: value });
            if (data) {
                setModelData(data.body.results[0]['items']);
            }
        }, 200);
    }, []);
    // 点击示例事件
    const onRandomClick = () => {
        const length = randomTextData.length - 1;
        const getRandomCount = Math.round(Math.random() * length);
        console.log('getRandomCount:', getRandomCount);
        setCurrentValue(randomTextData[getRandomCount]);
        getTextInfo(randomTextData[getRandomCount]);
    }
    // 中文名次短语标注工具  示例
    const [onlineData, setonlineData]: any = useState([]);
    const [currentValues, setCurrentValues]: any = useState('和原甫省中种菊');
    const randomTextonlineData = [
        '对硝基苯甲酸甲酯',
        '致远号穹甲巡洋舰',
        '大海在呼唤',
        '叶北华',
    ];
    const getTextonlineInfo = useMemo(() => {
        return debounce(async (value: string) => {
            const ondata = await fetchOnlineListModel({ text: value });
            if (ondata) {
                setonlineData(ondata.body.results);
            }
        }, 200);
    }, []);
    // 点击示例事件
    const onRandomOnlineClick = () => {
        const length = randomTextonlineData.length - 1;
        const getRandomCounts = Math.round(Math.random() * length);
        setCurrentValues(randomTextonlineData[getRandomCounts]);
        getTextonlineInfo(randomTextonlineData[getRandomCounts]);
    }
    // 工具集文本框输入文本触发事件改变
    const handleValueChange = async (value: any) => {
        getTextInfo(value.target.value);
        setCurrentValue(value.target.value);

    };
    const handleValueChanges = async (value: any) => {
        getTextonlineInfo(value.target.value);
        setCurrentValues(value.target.value);
    };
    useMemo(async () => {
        const data = await fetchListModel({ text: "《孤女》是2010年九州出版社出版的小说，作者是余兼羽" });
        setModelData(data?.body?.results[0]['items']);
        const ondata = await fetchOnlineListModel({ text: "和原甫省中种菊" });
        setonlineData(ondata?.body?.results);
    }, [setonlineData, setModelData]);

    useEffect(() => {
        if (!window.location.hash) {
            return;
        }
        const anchorID = window.location.hash.replace('#', '');
        const anchorDom = document.querySelector(`#${anchorID}`);
        setTimeout(() => {
            if (anchorID && anchorDom) {
                anchorDom.scrollIntoView({
                    block: 'start',
                    behavior: 'smooth'
                })
            }
        }, 800)
    }, []);

    return (
        <div className="">
            <Header />
            <div className="paddlenlp-page-title">
                <div className="title-t">PaddleNLP - 解语</div>
                <div className="introduce">
                    <div className="introduce-word" {...{ dangerouslySetInnerHTML: { __html: introduce } }} />
                </div>
                <div>
                    <a href='https://github.com/PaddlePaddle/PaddleNLP/tree/develop/examples/text_to_knowledge' target='blank' >
                        <Button type="primary" shape="round" >
                            前往Github
                        </Button>
                    </a>
                </div>
            </div>
            <div className="br-line"></div>
            <div className="paddlenlp-page-core">
                <div className="core-t">核心构成</div>

                <Core  {...coerpation} />
            </div>
            <div className="paddlenlp-page-tree" id='termtree'>
                <div className="tree-t">百科知识树</div>
                <div className="treeduce">
                    <div className="treeduce-word" {...{ dangerouslySetInnerHTML: { __html: treeduce } }} />
                    <div className="treepic"> <img src={treepic} alt="" /></div>
                    <a href="https://github.com/PaddlePaddle/PaddleNLP/tree/develop/examples/text_to_knowledge/termtree" target="black">
                        <Button className="tree-btn">了解详情</Button>
                    </a>
                </div>
            </div>
            {/* 中文词类知识标注工具 */}
            <div className="paddlenlp-page-tool" id='wordtag'>
                <div className="tool-t">中文词类知识标注工具</div>
                <div className="tool-adv-t">产品优势</div>
                <div className="adv-title">WordTag是首个能够覆盖所有中文词汇的词类知识标注工具，旨在为中文文本解析提供全面、丰富的知识标注结果</div>
                <Advantage  {...advantage} />
                <div className="tool-online">线上体验</div>
                <div className="online-text">
                    <div className="text-top">请输入一段想分析的文本：
                        <span
                            className="lexical-demo-input-label-link"
                            onClick={onRandomClick}
                        >
                            点击获取随机示例
                        </span>
                    </div>
                    {/* 输入文本框 */}
                    <Input.TextArea className="lexical-demo-input-textarea" onChange={handleValueChange} value={currentValue}></Input.TextArea>
                    <div className="reasoult">分析结果：</div>
                    <div className="reasoult-list">
                        <ListMap modelData={modelData} />
                    </div>
                </div>
                <a href="https://github.com/PaddlePaddle/PaddleNLP/tree/develop/examples/text_to_knowledge/wordtag" target="black">
                    <Button className="online-btn">了解详情</Button>
                </a>

            </div>
            {/* 中文名词短语标注工具 */}
            <div className="paddlenlp-page-tool" id='nptag'>
                <div className="tool-t">中文名词短语标注工具</div>
                <div className="tool-adv-t">产品优势</div>
                <div className="adv-title">NPTag是首个中文名词性短语细粒度上位标注工具，覆盖所有中文名词词汇，旨在解决复合名词和名词短语的未收录问题</div>
                <Advantagen  {...advantagen} />
                <div className="tool-online">线上体验</div>
                <div className="online-text">
                    <div className="text-top">请输入一段想分析的文本：
                        <span
                            className="lexical-demo-input-label-link"
                            onClick={onRandomOnlineClick}
                        >
                            点击获取随机示例
                        </span>
                    </div>
                    {/* 输入文本框 */}
                    <Input.TextArea className="lexical-demo-input-textarea" onChange={handleValueChanges} value={currentValues}></Input.TextArea>
                    <div className="reasoult">分析结果：</div>
                    <div className="reasoult-list">
                        <Online onlineData={onlineData} />
                    </div>
                </div>
                <a href={more} target="black">
                    <Button className="online-btn">了解详情</Button>
                </a>

            </div>
            <div className="paddlenlp-page-model" id='ernie-ctm'>
                <div className="model-t">中文预训练语言模型</div>
                <div className="model-desc">
                    ERNIE-CTM是适用于中文文本挖掘任务的预训练语言模型，
                    拥有更全面的汉字字表集合，更优的中文文本挖掘任务表现，
                    与PaddleNLP深度结合，
                    提供更加便捷的应用实践。
                </div>
                <Model  {...model} />

                <a href="https://github.com/PaddlePaddle/PaddleNLP/tree/develop/examples/text_to_knowledge/ernie-ctm" target="blacnk">
                    <Button className="model-btn">了解详情</Button>
                </a>

            </div>
            <Footer />
        </div>
    );
};

export default Paddlenlp